import { render, staticRenderFns } from "./PropertyDivisionCompanionAnimal.vue?vue&type=template&id=17937fa4&scoped=true"
import script from "./PropertyDivisionCompanionAnimal.vue?vue&type=script&lang=ts"
export * from "./PropertyDivisionCompanionAnimal.vue?vue&type=script&lang=ts"
import style0 from "./PropertyDivisionCompanionAnimal.vue?vue&type=style&index=0&id=17937fa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17937fa4",
  null
  
)

export default component.exports